import queryString from 'query-string';

export default function getUrlParams() {
    const url = window.location.href;
    const urlParamsString = url.slice((url.indexOf('?')) + 1);
    return queryString.parse(urlParamsString);
};
